import React, { useState } from 'react'
import Select, { InputActionMeta, MenuPlacement } from 'react-select'
import { aramayaUyar } from './secimArama'
import { Helpers } from '../helpers/Helpers';
import { toast } from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { storeActivityIndicator } from '../redux/reducers/authSlice';
import { AddConstantResponse } from '../models/response/constant/AddConstantResponse';
import { ConstantService } from '../services/ConstantService';
import Tooltip from './Tooltip';

export interface CustomSingleSelectModel {
    label: string;
    value: string;
    additionalValue1?: string | undefined
}

interface CustomSingleSelectOnSubmitModel {
    code?: string
    parentConstantId?: string
    onSubmit?: (_insertedValue: string) => void
}

interface Insertable {
    onSubmit?: CustomSingleSelectOnSubmitModel
    onClick?: () => void
    tooltipText?: string | undefined
    tooltipDirection?: 'top' | undefined
}

interface Props {
    onChange: (_selectedItem: CustomSingleSelectModel | undefined) => void
    selectedValue: CustomSingleSelectModel | undefined
    insertable: Insertable | undefined
    menuPlacement: MenuPlacement | undefined
    disabled: boolean
    onMenuOpen: ((searchTerm: string | undefined) => Promise<any>) | ((searchTerm: string | undefined) => Promise<any>)[] | undefined
    labelName: 'refNo' | 'baseAntrepoFullName' | 'name' | 'value' | 'nameSurname' | 'plate' | 'additionalValue1' | 'gTip1' | 'addressTypeName' | 'label' | 'phone' | 'deviceNo' | 'vehicleName' | 'countyName' | 'regionName' | 'withholdingRateName' | 'divisionName'
    label2Name?: 'gTipDesc' | 'value' | 'refNo' | 'name' | 'countyName' | 'districtName'
    valueName: 'deviceId' | 'agreementId' | 'priceId' | 'antrepoAreaId' | 'antrepoId' | 'constantId' | 'companyId' | 'driverId' | 'vehicleId' | 'gTipId' | 'serviceId' | 'addressTypeId' | 'value' | 'caseId' | 'containerId' | 'menuId' | 'personnelId' | 'productId' | 'countryId' | 'gsmStockId' | 'stockId' | 'id' | 'yurticiCargoAgreementSchemeId' | 'regionId' | 'withholdingId' | 'ambarAgreementSchemeId' | 'divisionId'
    additionalValue1Name: string | undefined
    innerPropName: string | undefined
    isPaging: boolean
    tabIndex: number | undefined
    placeholder: string
    isOrdering: boolean
    labelText: string | undefined
    isLabelRequired: boolean
    label3Name?: 'gTipDesc' | 'value' | 'refNo' | 'name' | 'countyName' | 'districtName'

    /**
     * Acilir liste sayfa govdesinde (portal) cizilir. Tablo hucresi gibi tasani
     * kirpan (overflow: hidden) bir kabin icinde kullanilirken gerekir; yoksa liste
     * hucrenin icinde kalir ve hic gorunmez.
     */
    menuPortal?: boolean
}

const CustomSingleSelect = ({
    onChange,
    selectedValue,
    insertable,
    menuPlacement,
    disabled,
    onMenuOpen,
    labelName,
    valueName,
    additionalValue1Name,
    label2Name,
    innerPropName,
    isPaging,
    tabIndex,
    placeholder,
    isOrdering,
    labelText,
    isLabelRequired,
    label3Name,
    menuPortal
}: Props) => {
    const dispatch = useDispatch();
    const [isInserting, setIsInserting] = useState(false);
    const [insertValue, setInsertValue] = useState('');
    const [items, setItems] = useState<CustomSingleSelectModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const [timeoutt, setTimeoutt] = useState<NodeJS.Timeout | undefined>(undefined);

    const addConstant = async (_code: string, _parentConstantId: string | undefined = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: AddConstantResponse = await ConstantService.addConstant(undefined, _code, insertValue, _parentConstantId);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message);

            onChange({ label: response.data.value, value: response.data.constantId });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const submitHandler = () => {
        if (insertable) {
            if (Helpers.isEmpty(insertValue)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }

            if (insertable && insertable.onSubmit)
                if (insertable.onSubmit.code)
                    addConstant(insertable.onSubmit.code, insertable.onSubmit.parentConstantId);
                else if (insertable.onSubmit.onSubmit)
                    insertable.onSubmit.onSubmit(insertValue);

            setIsInserting(false);
            setInsertValue('');
        }
    }

    const uniqueByKey = (array: any[] = [], key = '') => {
        if (!key) {
            return array;
        }

        return [
            ...new Map(
                array
                    .filter(Boolean)
                    .map((item) => [item[key], item]),
            ).values(),
        ];
    };


    const handleOnMenuOpen = async (_searchValue: string | undefined = undefined) => {
        try {
            if (onMenuOpen) {
                setIsLoading(true);

                var allTempItems: any[] = []

                var _onMenuOpen = Array.isArray(onMenuOpen) ? onMenuOpen : [onMenuOpen];

                for (var i = 0; i < _onMenuOpen.length; i++) {
                    var response: any = await _onMenuOpen[i](_searchValue);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        return;
                    }

                    if (innerPropName) {
                        response = {
                            data: response.data[innerPropName]
                        }
                    }

                    var tempItems = response.data.map(function (x: any) {
                        return {
                            isDisabled: x.isDisabled,
                            label: x[labelName].toString() + (label2Name ? (' - ' + x[label2Name]) : '') + (label3Name ? (' - ' + x[label3Name]) : ''),
                            value: x[valueName].toString(), additionalValue1: (additionalValue1Name ? x[additionalValue1Name] : undefined)
                        }
                    })

                    allTempItems = [...allTempItems, ...tempItems];
                }

                if (isOrdering) {
                    var newList = [];
                    var uniqueValues = [...new Set(allTempItems.map(x => x.value))];

                    for (var i = 0; i < uniqueValues.length; i++) {
                        newList.push(allTempItems.find(x => x.value == uniqueValues[i]));
                    }

                    newList = newList.sort((a, b) => a.label.localeCompare(b.label));

                    setItems(newList);
                }
                else {
                    setItems(allTempItems);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }

            <div className='d-flex'>
                <div className='d-flex flex-grow-1'>
                    {
                        !isInserting ?
                            (
                                <Select
                                    tabIndex={tabIndex}
                                    loadingMessage={() => 'Yükleniyor...'}
                                    onInputChange={(newValue: string, actionMeta: InputActionMeta) => {
                                        if (actionMeta.action == 'input-change') {
                                            setSearchValue(newValue);

                                            if (isPaging) {
                                                setTimeoutt((_timeout) => {
                                                    if (_timeout)
                                                        clearTimeout(_timeout);

                                                    _timeout = setTimeout(() => {
                                                        handleOnMenuOpen(newValue);
                                                        setTimeoutt(undefined);
                                                    }, 1000);

                                                    return _timeout;
                                                });
                                            }
                                        }
                                    }}
                                    isLoading={isLoading}
                                    onMenuOpen={handleOnMenuOpen}
                                    menuPortalTarget={menuPortal ? document.body : undefined}
                                    styles={menuPortal ? { menuPortal: (base) => ({ ...base, zIndex: 9999 }) } : undefined}
                                    onMenuClose={() => setItems([])}
                                    isDisabled={disabled}
                                    menuPlacement={menuPlacement}
                                    className='react-select-styled react-select-solid'
                                    classNamePrefix='react-select'
                                    options={(timeoutt ? [] : items.length > 100 ? items.filter(x => aramayaUyar(x.label, searchValue)).slice(0, 100) : items.filter(x => aramayaUyar(x.label, searchValue))).map(function (x) {
                                        return { ...x }
                                    })}
                                    placeholder={placeholder}
                                    isMulti={false}
                                    onChange={(e) => { onChange(e ? { label: e.label, value: e.value, additionalValue1: e.additionalValue1 } : undefined) }}
                                    value={selectedValue ? selectedValue : { label: placeholder, value: '' }}
                                    closeMenuOnSelect={true}
                                    isClearable
                                    filterOption={() => true}
                                    noOptionsMessage={() => 'Kayıt bulunamadı.'}
                                />
                            )
                            :
                            (
                                <React.Fragment>
                                    <input placeholder='Giriniz...' value={insertValue} onChange={(e) => setInsertValue(e.target.value)} type="email" className="form-control form-control-solid" />
                                </React.Fragment>
                            )
                    }
                </div>

                {

                    (!disabled && insertable && (insertable.onClick || insertable.onSubmit)) && (
                        <React.Fragment>
                            {
                                !isInserting
                                    ?
                                    (
                                        <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                            <Tooltip content={insertable.tooltipText} direction={insertable.tooltipDirection}>
                                                <i onClick={insertable.onClick ? insertable.onClick : () => setIsInserting(true)} style={{ fontSize: 22 }} className='actionIcon text-success fa fa-plus-circle' />
                                            </Tooltip>
                                        </div>
                                    )
                                    :
                                    (
                                        <React.Fragment>
                                            <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                                <i onClick={submitHandler} style={{ fontSize: 22 }} className='actionIcon text-success fa fa-check-circle' />
                                            </div>
                                            <div style={{ marginLeft: 10 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setIsInserting(false); setInsertValue(''); }} style={{ fontSize: 22 }} className='actionIcon text-danger fa fa-times-circle' />
                                            </div>
                                        </React.Fragment>
                                    )

                            }
                        </React.Fragment>
                    )
                }
            </div>
        </React.Fragment>
    )
}

CustomSingleSelect.defaultProps = {
    insertable: undefined,
    menuPlacement: 'auto',
    disabled: false,
    additionalValue1Name: undefined,
    innerPropName: undefined,
    isPaging: false,
    tabIndex: undefined,
    placeholder: 'Seçiniz',
    isOrdering: true,
    labelText: undefined,
    isLabelRequired: false
}

export default CustomSingleSelect;